import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/navigation/Header';
import Breadcrumb from '../../components/navigation/Breadcrumb';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';
import ConfirmationDialog from '../results-management/components/ConfirmationDialog';

const WinnerAnnouncement = () => {
  const navigate = useNavigate();
  const [selectedTournament, setSelectedTournament] = useState('icc-t20-wc-2026');
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [announcementStatus, setAnnouncementStatus] = useState(null);

  const mockTournaments = [
  {
    id: 'icc-t20-wc-2026',
    name: 'ICC T20 World Cup 2026',
    status: 'completed',
    endDate: '2026-06-21',
    prize1: 'iPad Pro 12.9-inch',
    prize2: '$500 Amazon Gift Card',
    prize3: 'Wireless Headphones',
    participants: 1247,
    totalMatches: 45,
    isAnnounced: false
  },
  {
    id: 'ipl-2026',
    name: 'IPL 2026',
    status: 'completed',
    endDate: '2026-05-28',
    prize1: 'MacBook Air M2',
    prize2: '$300 Flipkart Voucher',
    prize3: 'Smart Watch',
    participants: 892,
    totalMatches: 74,
    isAnnounced: true
  }];


  const mockLeaderboard = [
  {
    id: 'u1',
    rank: 1,
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@company.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_177afdf6c-1773056143448.png",
    avatarAlt: 'Professional man with beard wearing blue shirt smiling at camera',
    totalPoints: 1450,
    correctPredictions: 38,
    totalPredictions: 45,
    accuracy: 84.4,
    pointsBreakdown: {
      tournamentPredictions: 850,
      matchPredictions: 380,
      bonusPoints: 150,
      confidenceBonus: 70
    }
  },
  {
    id: 'u2',
    rank: 2,
    name: 'Priya Sharma',
    email: 'priya.sharma@company.com',
    avatar: "https://images.unsplash.com/photo-1575090973814-063b180ffef9",
    avatarAlt: 'Young woman with long dark hair smiling warmly',
    totalPoints: 1380,
    correctPredictions: 36,
    totalPredictions: 45,
    accuracy: 80.0,
    pointsBreakdown: {
      tournamentPredictions: 800,
      matchPredictions: 360,
      bonusPoints: 140,
      confidenceBonus: 80
    }
  },
  {
    id: 'u3',
    rank: 3,
    name: 'Amit Patel',
    email: 'amit.patel@company.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1afc3299d-1772998695405.png",
    avatarAlt: 'Man with short hair and casual attire looking confident',
    totalPoints: 1320,
    correctPredictions: 35,
    totalPredictions: 45,
    accuracy: 77.8,
    pointsBreakdown: {
      tournamentPredictions: 780,
      matchPredictions: 350,
      bonusPoints: 120,
      confidenceBonus: 70
    }
  },
  {
    id: 'u4',
    rank: 4,
    name: 'Sarah Johnson',
    email: 'sarah.j@company.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11d684987-1772697167208.png",
    avatarAlt: 'Professional woman with blonde hair in business attire',
    totalPoints: 1280,
    correctPredictions: 34,
    totalPredictions: 45,
    accuracy: 75.6,
    pointsBreakdown: {
      tournamentPredictions: 750,
      matchPredictions: 340,
      bonusPoints: 120,
      confidenceBonus: 70
    }
  },
  {
    id: 'u5',
    rank: 5,
    name: 'Michael Chen',
    email: 'michael.chen@company.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1add37a33-1763296420971.png",
    avatarAlt: 'Asian man with glasses wearing casual shirt',
    totalPoints: 1240,
    correctPredictions: 33,
    totalPredictions: 45,
    accuracy: 73.3,
    pointsBreakdown: {
      tournamentPredictions: 720,
      matchPredictions: 330,
      bonusPoints: 120,
      confidenceBonus: 70
    }
  }];


  const selectedTournamentData = mockTournaments?.find((t) => t?.id === selectedTournament);

  const getRankIcon = (rank) => {
    if (rank === 1) return { name: 'Trophy', color: '#FFD700' };
    if (rank === 2) return { name: 'Medal', color: '#C0C0C0' };
    if (rank === 3) return { name: 'Award', color: '#CD7F32' };
    return null;
  };

  const getPrizeForRank = (rank) => {
    if (rank === 1) return selectedTournamentData?.prize1;
    if (rank === 2) return selectedTournamentData?.prize2;
    if (rank === 3) return selectedTournamentData?.prize3;
    return null;
  };

  const handleAnnounceWinners = () => {
    setShowConfirmDialog(true);
  };

  const confirmAnnouncement = () => {
    setShowConfirmDialog(false);
    setAnnouncementStatus('success');
    setTimeout(() => {
      setAnnouncementStatus(null);
    }, 5000);
  };

  const breadcrumbItems = [
  { label: 'Admin Dashboard', path: '/admin-dashboard' },
  { label: 'Winner Announcement', path: '/winner-announcement' }];


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-6 md:py-8">
        <Breadcrumb items={breadcrumbItems} />

        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2 flex items-center gap-3">
            <Icon name="Trophy" size={32} color="var(--color-primary)" />
            Winner Announcement
          </h1>
          <p className="text-sm md:text-base text-muted-foreground">
            Announce tournament winners, display final leaderboard, and confirm prize allocation
          </p>
        </div>

        {announcementStatus === 'success' &&
        <div className="mb-6 bg-success/10 border border-success/20 rounded-lg p-4 flex items-start gap-3">
            <Icon name="CheckCircle" size={24} color="var(--color-success)" />
            <div>
              <h3 className="font-semibold text-success mb-1">Winners Announced Successfully!</h3>
              <p className="text-sm text-success/80">
                All participants have been notified via email with their final rankings and prize details.
              </p>
            </div>
          </div>
        }

        <div className="bg-card rounded-lg shadow-elevation-sm border border-border p-4 md:p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div className="flex-1">
              <label className="block text-sm font-semibold text-foreground mb-2">
                Select Tournament
              </label>
              <Select
                value={selectedTournament}
                onChange={(e) => setSelectedTournament(e?.target?.value)}
                className="max-w-md">

                {mockTournaments?.map((tournament) =>
                <option key={tournament?.id} value={tournament?.id}>
                    {tournament?.name} - {tournament?.status === 'completed' ? 'Completed' : 'Ongoing'}
                  </option>
                )}
              </Select>
            </div>

            {selectedTournamentData?.status === 'completed' &&
            <div className="flex items-center gap-2">
                {selectedTournamentData?.isAnnounced ?
              <div className="flex items-center gap-2 bg-success/10 px-4 py-2 rounded-lg border border-success/20">
                    <Icon name="CheckCircle" size={20} color="var(--color-success)" />
                    <span className="text-sm font-semibold text-success">Winners Announced</span>
                  </div> :

              <div className="flex items-center gap-2 bg-warning/10 px-4 py-2 rounded-lg border border-warning/20">
                    <Icon name="Clock" size={20} color="var(--color-warning)" />
                    <span className="text-sm font-semibold text-warning">Pending Announcement</span>
                  </div>
              }
              </div>
            }
          </div>

          {selectedTournamentData &&
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Users" size={18} color="var(--color-primary)" />
                  <p className="text-xs text-muted-foreground">Total Participants</p>
                </div>
                <p className="text-xl md:text-2xl font-bold text-foreground data-text">
                  {selectedTournamentData?.participants}
                </p>
              </div>

              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Calendar" size={18} color="var(--color-primary)" />
                  <p className="text-xs text-muted-foreground">Total Matches</p>
                </div>
                <p className="text-xl md:text-2xl font-bold text-foreground data-text">
                  {selectedTournamentData?.totalMatches}
                </p>
              </div>

              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="CalendarCheck" size={18} color="var(--color-success)" />
                  <p className="text-xs text-muted-foreground">End Date</p>
                </div>
                <p className="text-sm md:text-base font-semibold text-foreground">
                  {new Date(selectedTournamentData?.endDate)?.toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
                </p>
              </div>

              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Award" size={18} color="var(--color-accent)" />
                  <p className="text-xs text-muted-foreground">Status</p>
                </div>
                <p className="text-sm md:text-base font-semibold text-foreground capitalize">
                  {selectedTournamentData?.status}
                </p>
              </div>
            </div>
          }
        </div>

        <div className="bg-card rounded-lg shadow-elevation-sm border border-border p-4 md:p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground flex items-center gap-2">
              <Icon name="Gift" size={24} color="var(--color-accent)" />
              Prize Allocation
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg p-6 border-2 border-primary/30">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-14 h-14 bg-primary/20 rounded-lg flex items-center justify-center">
                  <Icon name="Trophy" size={28} color="#FFD700" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">1st Place</p>
                  <p className="text-lg font-bold text-foreground">Champion</p>
                </div>
              </div>
              <div className="bg-card rounded-lg p-4 border border-border">
                <p className="text-xs text-muted-foreground mb-1">Prize</p>
                <p className="text-base md:text-lg font-bold text-primary">
                  {selectedTournamentData?.prize1}
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-accent/10 to-accent/5 rounded-lg p-6 border-2 border-accent/30">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-14 h-14 bg-accent/20 rounded-lg flex items-center justify-center">
                  <Icon name="Medal" size={28} color="#C0C0C0" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">2nd Place</p>
                  <p className="text-lg font-bold text-foreground">Runner-up</p>
                </div>
              </div>
              <div className="bg-card rounded-lg p-4 border border-border">
                <p className="text-xs text-muted-foreground mb-1">Prize</p>
                <p className="text-base md:text-lg font-bold text-accent">
                  {selectedTournamentData?.prize2}
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-success/10 to-success/5 rounded-lg p-6 border-2 border-success/30">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-14 h-14 bg-success/20 rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={28} color="#CD7F32" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">3rd Place</p>
                  <p className="text-lg font-bold text-foreground">Third Place</p>
                </div>
              </div>
              <div className="bg-card rounded-lg p-4 border border-border">
                <p className="text-xs text-muted-foreground mb-1">Prize</p>
                <p className="text-base md:text-lg font-bold text-success">
                  {selectedTournamentData?.prize3}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-lg shadow-elevation-sm border border-border p-4 md:p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground flex items-center gap-2">
              <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
              Final Leaderboard
            </h2>
            <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
              Export
            </Button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground">Rank</th>
                  <th className="text-left py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground">Player</th>
                  <th className="text-right py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground">Points</th>
                  <th className="text-right py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground hidden md:table-cell">Predictions</th>
                  <th className="text-right py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground hidden lg:table-cell">Accuracy</th>
                  <th className="text-left py-3 px-2 text-xs md:text-sm font-semibold text-muted-foreground">Prize</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {mockLeaderboard?.map((user) => {
                  const rankIcon = getRankIcon(user?.rank);
                  const prize = getPrizeForRank(user?.rank);

                  return (
                    <tr key={user?.id} className="hover:bg-muted/30 transition-colors">
                      <td className="py-4 px-2">
                        <div className="flex items-center gap-2">
                          {rankIcon ?
                          <Icon name={rankIcon?.name} size={24} color={rankIcon?.color} /> :

                          <span className="text-sm md:text-base font-bold text-foreground w-6 text-center">
                              {user?.rank}
                            </span>
                          }
                        </div>
                      </td>
                      <td className="py-4 px-2">
                        <div className="flex items-center gap-3">
                          <Image
                            src={user?.avatar}
                            alt={user?.avatarAlt}
                            className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" />

                          <div className="min-w-0">
                            <p className="font-semibold text-foreground text-sm md:text-base truncate">
                              {user?.name}
                            </p>
                            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-2 text-right">
                        <span className="text-lg md:text-xl font-bold text-primary data-text">
                          {user?.totalPoints}
                        </span>
                      </td>
                      <td className="py-4 px-2 text-right hidden md:table-cell">
                        <span className="text-sm md:text-base text-foreground data-text">
                          {user?.correctPredictions}/{user?.totalPredictions}
                        </span>
                      </td>
                      <td className="py-4 px-2 text-right hidden lg:table-cell">
                        <span className="text-sm md:text-base text-foreground data-text">
                          {user?.accuracy}%
                        </span>
                      </td>
                      <td className="py-4 px-2">
                        {prize ?
                        <div className="flex items-center gap-2">
                            <Icon name="Gift" size={16} color="var(--color-accent)" />
                            <span className="text-xs md:text-sm font-semibold text-accent truncate max-w-[150px]">
                              {prize}
                            </span>
                          </div> :

                        <span className="text-xs md:text-sm text-muted-foreground">-</span>
                        }
                      </td>
                    </tr>);

                })}
              </tbody>
            </table>
          </div>

          {selectedTournamentData?.status === 'completed' && !selectedTournamentData?.isAnnounced &&
          <div className="mt-6 pt-6 border-t border-border">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-start gap-3">
                  <Icon name="Info" size={20} color="var(--color-primary)" />
                  <div>
                    <p className="text-sm font-semibold text-foreground mb-1">
                      Ready to announce winners?
                    </p>
                    <p className="text-xs text-muted-foreground">
                      This will notify all participants via email and publish the final results.
                    </p>
                  </div>
                </div>
                <Button
                variant="default"
                size="lg"
                iconName="Send"
                iconPosition="right"
                onClick={handleAnnounceWinners}
                className="w-full md:w-auto">

                  Announce Winners
                </Button>
              </div>
            </div>
          }
        </div>
      </div>
      <ConfirmationDialog
        isOpen={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={confirmAnnouncement}
        title="Confirm Winner Announcement"
        message={`Are you sure you want to announce the winners for ${selectedTournamentData?.name}? This action will send email notifications to all ${selectedTournamentData?.participants} participants with their final rankings and prize details.`}
        confirmText="Announce Winners"
        type="default" />

    </div>);

};

export default WinnerAnnouncement;